/* global axios */
import ApiClient from './ApiClient';

class TicketImportAPI extends ApiClient {
  constructor() {
    super('ticket_imports', { accountScoped: true });
  }

  create({ file, kanbanfunnelId, columnsId, priority, mapping, userId }) {
    const formData = new FormData();
    formData.append('import_file', file);
    formData.append('kanbanfunnel_id', kanbanfunnelId);
    formData.append('columns_id', columnsId);
    formData.append('priority', priority);
    formData.append('mapping', JSON.stringify(mapping));
    if (userId) formData.append('user_id', userId);

    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getStatus(id) {
    return axios.get(`${this.url}/${id}`);
  }
}

export default new TicketImportAPI();
